export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  // Overview Module
  'menu.overview': 'Overview',
  'menu.overview.dashboard': 'Dashboard',
  'menu.overview.prd': 'PRD Management',
  'menu.overview.theme': 'Theme Management',
  // Tenant Management
  'menu.tenant': 'Tenant',
  'menu.tenant.list': 'Tenant List',
  'menu.tenant.package': 'Package',
  'menu.tenant.store': 'Store',
  'menu.tenant.mall': 'Mall',
  'menu.tenant.uploadlog': 'Upload Log',
  'menu.tenant.deadline': 'Deadline',
  // Agent Center
  'menu.agent': 'Agent',
  'menu.agent.profile': 'Agent List',
  // Device Authorization
  'menu.device': 'Device Management',
  'menu.device.register': 'Device Terminal',
  'menu.device.log': 'Device Log',
  'menu.device.opsConsole': 'Ops Console',
  // System Settings
  'menu.setting': 'Setting',
  'menu.setting.user': 'User',
  'menu.setting.role': 'Role',
  'menu.setting.menu': 'Menu',
  'menu.setting.department': 'Department',
  'menu.setting.dictionary': 'Dictionary',
  'menu.setting.parameter': 'Parameter',
  // Operations Management
  'menu.ops': 'Operations',
  'menu.ops.cron': 'Cron Jobs',
  'menu.ops.version': 'Version',
  'menu.ops.template': 'Message Template',
  'menu.ops.message': 'Message',
  // B Account
  'menu.accountB': 'B Account',
  'menu.accountB.accountBConfig': 'B Account Config',
  'menu.accountB.dataReset': 'B Account Data Reset',
  'menu.accountB.generateLog': 'B Account Generate Log',
  // Log Management
  'menu.log': 'Log',
  'menu.log.operation': 'Operation Log',
  'menu.log.login': 'Login Log',
  'menu.log.audit': 'Audit Log',
  'menu.log.rawIngestion': 'Upload Payloads',
  'menu.log.orderBatch': 'Order Batch Logs',
  'menu.log.operationalBatch': 'Operational Batch Logs',
  // Cron Tasks
  'menu.cron': 'Cron',
  'menu.cron.list': 'Task List',
  'menu.cron.record': 'Execution Record',
  // Mall
  'menu.mall': 'Mall',
  'menu.mall.config': 'Config List',
  // Tab titles for hidden pages (add/edit/detail are not in menu; tabs bar resolves key by path)
  'menu.tenant.list.add': 'Add Tenant',
  'menu.tenant.list.detail': 'Tenant Detail',
  'menu.tenant.list.edit': 'Edit Tenant',
  'menu.tenant.store.add': 'Add Store',
  'menu.tenant.store.edit': 'Edit Store',
  'menu.ops.version.add': 'Add Version',
  'menu.ops.version.edit': 'Edit Version',
  'menu.accountB.accountBConfiguration': 'B Account Config',
  'menu.accountB.accountBConfiguration.add': 'Add B Account Config',
  'menu.accountB.accountBConfiguration.detail': 'B Account Config Detail',
  'menu.accountB.accountBConfiguration.edit': 'Edit B Account Config',
  'menu.mall.config.add': 'Add Mall Config',
  'menu.mall.config.detail': 'Mall Config Detail',
  'menu.mall.config.edit': 'Edit Mall Config',
  // EIS e-invoice (HQ)
  'menu.eis': 'EIS e-Invoice',
  'menu.eis.monitor': 'EIS Monitor',
  'menu.eis.dataCenter': 'Data Center',
  'menu.eis.profile': 'EIS Profiles',
  // Tabs bar actions
  'tabs.close.left': 'Close Left',
  'tabs.close.right': 'Close Right',
  'tabs.close.others': 'Close Others',
  'tabs.refresh': 'Refresh',
};
